import { Routes, RouterModule, Router } from '@angular/router';
import { LoginComponent }   from './login/login.component';
import { DispatcherComponent }   from './dispatcher/dispatcher.component';
import { DispatcherHomeComponent }   from './dispatcher/dispatcherhome/dispatcherhome.component';
import { TasksComponent }   from './dispatcher/tasks/tasks.component';
import { AccountComponent }   from './dispatcher/account/account.component';
import { WalletComponent }   from './dispatcher/wallet/wallet.component';
import { AuthGaurdService as AuthGuard } from './auth-gaurd.service';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'dispatcher', component: DispatcherComponent, canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dispatcherhome', pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'dispatcherhome', component: DispatcherHomeComponent, canActivate: [AuthGuard] },
      { path: 'tasks', component: TasksComponent, canActivate: [AuthGuard] },
      { path: 'account', component: AccountComponent, canActivate: [AuthGuard] },
      { path: 'wallet', component: WalletComponent, canActivate: [AuthGuard] }
    ]
  }
];

export const routing = RouterModule.forRoot(routes, { useHash: true });


// WEBPACK FOOTER //
// F:/Karry/Zoom/ZoomCustomer/src/app/app.routing.ts